/**
 *
 * @deprecated use selector instead
 */
function mapStateToFormProps(state, ownProps) {
  return {
    app: state.app,
    key: `${ownProps.formKey}_${ownProps.formEntityId}`,
    instance: state.data.instance || '',
    newform: state.newform || '',
    alert: state.data.alert,
    describe: state.data.describe,
    focusArea: state.app.focusArea,
    autoFocus: state.app.autoFocus,
    haggle: state.haggle,
    actionEntities: state.app.actionEntities,
  };
}

export default mapStateToFormProps;
